import { SmartClub } from 'tokyu-hooks'

export const QUERY_GA_TAG_INFO_KEY = 'QUERY_GA_TAG_INFO_KEY'

export const fetchGaTagInfo =
  (smartClubId?: number, accessToken?: string) => async () => {
    if (!accessToken || !smartClubId) return null

    const res = await SmartClub.getGaTagInfo({
      baseUrl: process.env.NEXT_PUBLIC_SMART_CLUB_URL as string,
      smartClubId: smartClubId,
      accessToken,
    })

    return res?.data
  }
